import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SignatureStatus } from '@/types/transmissionReport';
import { PRACTITIONER_SIGNATURE_ROLES, User, UserRole } from '@/types/user';

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  isLoading: boolean;
  token: string | null;
  signatureStatus: SignatureStatus;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  isLoading: true,
  token: null,
  signatureStatus: SignatureStatus.NotSigned
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (
      state,
      action: PayloadAction<{
        isAuthenticated: boolean;
        user: User | null;
        token: string | null;
      }>
    ) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoading = false;
      if (
        action.payload.user?.role &&
        PRACTITIONER_SIGNATURE_ROLES.includes(action.payload.user.role as UserRole)
      ) {
        state.signatureStatus = SignatureStatus.NonPractitionerSigned;
      } else {
        state.signatureStatus = SignatureStatus.NotSigned;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.isLoading = false;
    }
  }
});

export const { setAuth, setLoading, setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;
